define('viewModels/privileged/qm/policies/editors/DnisSelectorView',[
    'lib/knockout',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n',
    'lib/knockout.validation'
], function (ko, ViewModel) {
    'use strict';

    /**
     * The DnisSelectorView class.
     * @class
     */
    var DnisSelectorView = ViewModel.extend(function (dnisObservable) {
        var self = this;

        self.dnis = ko.observable();

        self.subscribe(self.dnis, function(newValue) {
            if (newValue) {
                dnisObservable({ id: newValue, name: newValue });
                self.dnis(null);
            }
        });

    });

    return DnisSelectorView;
});
